import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PageVersionService } from '../../../shared/services/page-version/page-version.service';

/** Redirects v1/v2 URLs to the version chosen in Settings (default V2). */
export const pageVersionRedirectGuard: CanActivateFn = (_route, state) => {
  const redirect = PageVersionService.redirectUrlIfNeeded(state.url);
  if (!redirect || redirect === state.url) {
    return true;
  }
  return inject(Router).parseUrl(redirect);
};
